module.exports = __webpack_public_path__ + "static/media/012 I GUERRA M_Borgo emilio.1a9c0d2a.svg";